import { Button } from '@innovyze/stylovyze';
import { Button as ButtonMui, TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledContainer = styled.div`
	max-width: 750px;
	display: flex;
	flex-direction: row;
	justify-content: end;
	align-items: center;
	column-gap: 1em;
	row-gap: 1em;
`;

export const StyledButton = styled(Button)`
	white-space: nowrap;
	padding: 5px 33px;
	margin: 0;
	flex: 0 0 auto;
	height: min-content;
	width: min-content;
`;

export const StyledReadonlyTextField = styled(TextField)`
	flex: 1;
`;

export const StyledSubWrapper = styled.div`
	display: flex;
	grid-gap: 1em;
	justify-content: end;
	align-items: center;
`;

export const StyledCopyButton = styled(ButtonMui)<{ disabled: boolean }>`
	overflow: hidden;
	opacity: ${props => (props.disabled ? '0%' : '100%')};
	transition: all 0.25s ease-out;
	min-width: ${props => (props.disabled ? '0px' : '64px')};
	width: ${props => (props.disabled ? '0px' : '50px')};
	padding: ${props => (props.disabled ? '0px' : '6px 8px')};
`;
